export const getCommodityColor = (
  commodity = "water",
  effectiveProfile = {},
) => {
  const defaultColors = {
    water: "#2a9d8f",
    electricity: "#f6c21a",
    gas: "#ff6a00",
  };

  const estateColors = effectiveProfile?.streetId?.estateId?.colorSetting || {};

  const resolved =
    (commodity && estateColors?.[commodity]) ||
    defaultColors[commodity] ||
    defaultColors.water;

  return resolved;
};

export const applyCommodityTheme = (
  dispatch,
  commodity = "water",
  effectiveProfile = {},
) => {
  const color = getCommodityColor(commodity, effectiveProfile);
  dispatch({ type: "brandColor", payload: { brandColor: color } });
};
